import { Tab } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomTabs } from '../../../components/Forms/CustomTabs';
import UseUrlParam from "../../../components/Logic/UseUrlProps";
import RessourceMenu from "../../../components/RessourceMenu";
import TabPanel from "../../../components/TabPanel";
import { PermissionEnum } from "../../Permission/PermissionEnum";
import { AbilityContext } from "../../UserApi/logic/Can";
import { useGetRecordByIdQuery, useDeleteRecordByUuidMutation, useGetAllRecordsByOrgIdQuery } from "../redux/dnsApiSlice";
import InfoTab from "./tabs/InfoTab";
import { UserContext } from "../../UserApi/logic/FetchUser";
import { PaginationQueryPackage } from "../../../models/API/QueryParams/PaginationQueryPackage";

export interface RecordInfoDialogProps {
    recordUuid: string
    afterDeleteAction?: () => void
}

export const RecordInfoDialog = (props: RecordInfoDialogProps | UseUrlParam) => {

    const params = useParams();
    const urlPropsUuid = (props as UseUrlParam).shouldGetEntityFromUrl ? params["recordUuid"] : "";
    const recordPropsUuid = (props as RecordInfoDialogProps).recordUuid
    const recordUuid = recordPropsUuid ?? urlPropsUuid;

    const [value, setValue] = React.useState(0);
    const { t } = useTranslation()

    const userContext = useContext(UserContext);

    const { data } = useGetAllRecordsByOrgIdQuery({
        pagination: new PaginationQueryPackage(),
        uuid: userContext?.organisation?.uuid
    });

    const ability = useContext(AbilityContext)

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    if (!data) return <></>

    const labels = [t("Info")]
    const tabPanel = []

    tabPanel.push(
        <TabPanel
            value={value}
            index={tabPanel.length}
        >
            <InfoTab recordUuid={recordUuid!} />
        </TabPanel>
    )

    return (
        <>
            <CustomTabs
                value={value}
                onChange={handleChange}
                rightMenu={
                    <RessourceMenu
                        isAllowedToDelete={(data) => ability.can(PermissionEnum.AUTHORISATION_WRITE, data)}
                        nameOfRessource="record"
                        primaryButtonText={t("Record")}
                        idToFetch={recordUuid}
                        deleteMutation={useDeleteRecordByUuidMutation}
                        getByIdAction={useGetRecordByIdQuery}
                        afterDeleteAction={(props as RecordInfoDialogProps).afterDeleteAction}
                    />
                }
            >
                {labels.map(label => (<Tab key={label} label={label} />))}
            </CustomTabs>
            {tabPanel.map(tabPanel => tabPanel)}
        </>
    )
}